<template>
  <div
    class="p-container"
    :class="[{
      'is-paddingless-mobile': paddinglessMobile,
      'is-fluid': fluid,
    }, size]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    paddinglessMobile: {
      default: false,
      type: Boolean
    },
    fluid: {
      default: false,
      type: Boolean
    },
    size: {
      default: "",
      type: String
    }
  }
};
</script>
